var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExamModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77778 12.8889V5.77778C5.77778 5.30628 5.96508 4.8541 6.29848 4.5207C6.63187 4.1873 7.08406 4 7.55556 4H18.2222C18.6937 4 19.1459 4.1873 19.4793 4.5207C19.8127 4.8541 20 5.30628 20 5.77778V17.3333C20 18.2222 19.4667 20 17.3333 20M17.3333 20H6.66667C5.77778 20 4 19.4667 4 17.3333V15.5556H14.6667V17.3333C14.6667 19.4667 16.4444 20 17.3333 20ZM9.33333 7.55556H16.4444M9.33333 11.1111H12.8889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamModel);
export default __webpack_public_path__ + "static/media/ExamModel.9cd70cc0cf7c5e1d8d5ac6649d2f38ce.svg";
export { ForwardRef as ReactComponent };